<app-verwendung-card
  testId="test-case-usage-card"
  [subtitle]="'testCases.form.usage.subtitle' | translate"
  [tabs]="tabs()"
  [status]="status()"
  (erneutVersuchen)="erneutLaden()"
/>
